import { useEnviosFisicosMutation } from "../../../services/docs";
import { Spinner } from "../../../components/Spinner";
import Button from "../../../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import { useForm } from "../../../hooks/useForm";
import { Icon } from "../../../components/ui/Icon";

export const EnvioFisicoScreen = () => {
  const [cargaAction, { isLoading: cargando, data }] =
    useEnviosFisicosMutation();
  const { formulario, handleInputChange, handleSelectChange, handleChange } =
    useForm({
      fc_tipo: "",
      fc_inicial: "",
      fc_final: "",
    });

  const guardarArchivo = async () => {
    console.log(formulario);
    const resp = await cargaAction({
      ...formulario,
    })
      .unwrap()
      .catch((err) => {
        const errorData = err.data || err;
        console.log(errorData.message);
        const mensajes = errorData.message || "Ocurrió un error inesperado";
        const textoAMostrar = Array.isArray(mensajes)
          ? mensajes.join("<br>") // Separa los errores con un salto de línea en el Toastr
          : mensajes;
        console.log(textoAMostrar);
        toastr.error(textoAMostrar);
      });
    if (resp) {
      toastr.info("PDF Generado");
    }
  };
  return (
    <div className="card">
      <div className="space-y-6">
        <div className="mb-3 mt-5 w-full">
          <div className="flex items-center">
            <div className="w-3/4">
              <h6>Envio Fisico</h6>
            </div>
            <div className="mb-1 w-1/4"></div>
          </div>
          <hr />
        </div>

        <div className="grid grid-cols-3 place-items-stretch gap-4">
          <div className="flex flex-col px-6 py-2">
            <Label htmlFor="fc_tipo" className="my-2">
              Tipo de Certificado:
            </Label>
            <select
              className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded border border-gray-light bg-gray-ultra-light px-3 py-2 text-sm ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
              name="fc_tipo"
              onChange={handleSelectChange}
            >
              <option value="">Selecciona</option>
              <option value="N">Venta Nueva</option>
              <option value="R">Renovación</option>
            </select>
          </div>

          <div className="flex flex-col px-6 py-2">
            <Label className="my-2" htmlFor="fc_valor">
              Fecha Inicial:
            </Label>
            <Input type="date" name="fc_inicial" onChange={handleInputChange} />
          </div>
          <div className="flex flex-col px-6 py-2">
            <Label className="my-2" htmlFor="fc_valor">
              Fecha Final:
            </Label>
            <Input type="date" name="fc_final" onChange={handleInputChange} />
          </div>
        </div>
        {!cargando && (
          <div className="flex flex-col px-6 py-2">
            <Button onClick={guardarArchivo}>Generar Certificados</Button>
          </div>
        )}
        {cargando && (
          <div className="flex justify-center">
            <Spinner />
          </div>
        )}
      </div>

      {!cargando && data && data.archivo && (
        <div className="flex w-full flex-col justify-center justify-items-center px-6 py-2 text-center">
          <a
            href={data.archivo}
            target="_blank"
            className="flex w-full justify-center text-primary"
          >
            <Icon variante={"descarga"} />
          </a>
        </div>
      )}
    </div>
  );
};
